export default "__VITE_ASSET__BuQ1SSzz__"